import React from 'react';
import '../styles/styles.css';

export default function home() {
  return (
    <div className="container mt-4">
  <div className="row">
    {/* Left Large Image Box */}
    <div className="col-md-4 box1">
      <img src="/images/Kedarnath.jpeg" alt="Kedarnath" />
     {/*  <BackgroundAudio src="/audio/background.mp3" volume={0.2} />  */}

    </div>
    {/* Right Information Boxes */}
    <div className="col-md-8">
      <div className="Reg-box2">
        <p>
          <strong>
            Opening Dates
            <br />
            Kedarnath Dham : 02 - May, 2025
            <br />
            Badrinath Dham : 04 - May, 2025
            <br />
            <br />
          </strong>
        </p>
        <p>
          Registration link to Chardham Yatra :{" "}
          <a
            href="https://registrationandtouristcare.uk.gov.in/signin.php"
            target="_blank"
            rel="noopener noreferrer"
          >
            Chardham Yatra{" "}
          </a>
        </p>
      </div>
    </div>
  </div>
  {/* Bottom Full Width Description Box */}
  <div className="row mt-3">
    <div className="col-12 Desc-box3">
      <p>
        The Char Dham Yatra is a Hindu pilgrimage to four sacred sites in
        Uttarakhand, India. The sites are Yamunotri, Gangotri, Kedarnath, and
        Badrinath. Sri Guru Adi Shankaracharya initiated the Char Dham Yatra in
        the 8th century to rejuvenate the Hindu faith. Today, thousands of
        devotees from across the globe participate in this sacred journey. All
        these locations are believed to be highly sacred by the Hindu religion.
        While Kedarnath is home to lord Shiva and Badrinath is home to Lord
        Vishnu. Yamunotri represent goddess of Shakti Yamuna, and Gangotri
        represent goddess of Shakti Ganga.
      </p>
    </div>
  </div>
</div>
  )
}
